import * as types from "./action-type";

export const SetVoterListExportDataFlag = (dispatch: any, data: boolean) => {
  dispatch({ type: types.SET_EXPORT_VOTER_LIST, data });
};

export const setBallotItemInformationDetail = (data: any) => ({
  type: types.SET_BALLOT_ITEM_INFORMATION,
  data,
});

export const setNegativeRulingRationaleDetail = (data: any) => ({
  type: types.SET_NEGATIVE_RULING_RATIONALE,
  data,
});